import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { CheckIcon, KeyIcon, MailIcon } from "@heroicons/react/solid";
import { Col, Row, Card, Button, InputGroup, Modal, FormCheck, ToastContainer } from 'react-bootstrap';
import Select from 'react-select';
import CopyToClipboard from "react-copy-to-clipboard";
import { XCircleIcon } from "@heroicons/react/outline";
import { useCheckUserDetailsMutation, useCountriesOptionsMutation, useEditVendorAccountMutation } from "Services/services";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { CiEdit } from "react-icons/ci";
import { Toast } from 'react-bootstrap';

import {  VendorRegistrationListTable } from "./Tables";
import { MdOutlineAutoMode } from "react-icons/md";
import TableWrapper from "./TableWrapper";

export const GeneralInfoForm = () => {
  // Get the usertype from localStorage
  // const loggedUserData = localStorage.getItem('TOKEN');
  // const userObject = JSON.parse(loggedUserData);
  // const loggedUserType = userObject.user_type; 

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

  const [getCountries] = useCountriesOptionsMutation();
  const [verify] = useCheckUserDetailsMutation();
  const [userDetailUpdates] = useEditVendorAccountMutation();

  const [editDetails, setEditDetails] = useState({});
  const [previewDetails, setPreviewDetails] = useState({});
  const [isValidated, setIsValidated] = useState(false);

  const [countryOptions, setCountryOptions] = useState([]);
  
  const [showEdit, setShowEdit] = useState(false);
  const [showEditDefault, setShowEditDefault] = useState(false);
  const [copied, setCopied] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [isEditPassword, setIsEditPassword] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const fieldLabels = {
    vendor_name: 'Vendor Name',
    username: 'Username',
    vendor_country: 'Vendor Country',
    person_name: 'Contact Person Name',
    email: 'Email',
    phone: 'Contact Phone',
    website_url: 'Website URL',
    allow_ip: 'Allow IP',
    account_validity: 'Account Validity',
  };
 
  useEffect(()=> {
    const requiredFields = [
      'vendor_name',
      'username',
      'vendor_country',
      'person_name',
      'email',
      'phone',
      'website_url',
      'allow_ip',
      'account_validity',
    ];

    const missing = requiredFields.filter((field) => {
      const value = editDetails?.[field];
      return value === undefined || value === null || String(value).trim() === '';
    });

    setMissingFields(missing);
    setIsValidated(missing.length === 0);
  }, [editDetails])

  const handleEdit = async (userDetails) => {
    try {
      const response = await getCountries({ cname: "" });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.countries.map((item) => ({
          value: item.name,
          label: `${item.name} (${item.iso2})`,
        }));
        setCountryOptions(options);
      } else if (response.data.error) {
        console.error("API returned an error:", response.data.msg);
        setCountryOptions([]);
      }
    } catch (error) {
      setCountryOptions([]);
      console.error("Error fetching country data:", error);
    } finally {
    }

    const updateduserDetails = {
      ...userDetails,
      account_validity: moment(userDetails.account_validity).format("YYYY-MM-DD"),
    }

    setEditDetails(updateduserDetails);
    setShowEdit(true);
  };

  const [isVerifiedEmail, setisVerifiedEmail] = useState();
  const verifyEmail = (e) => {
    const newEmail = e.target.value;
    setEditDetails({...editDetails, email: newEmail });

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (regex.test(newEmail)) {
      const postData = { data: newEmail };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedEmail(true);
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedEmail(false);
            console.error("Verification failed");
          }
        })
        .catch((error) => {
          setisVerifiedEmail(false);
          console.error("Verification failed", error);
        });
    } else {
      setisVerifiedEmail(false);
    }
  };

  const [isVerifiedPhone, setisVerifiedPhone] = useState();
  const verifyPhone = (phone) => {
    setEditDetails({...editDetails, phone: phone });
    
    const regex = /^(\+|00)?\d{1,3}[-.\s]?\(?\d{1,4}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    if (phone.length >= 6 && phone.length <= 13 && regex.test(phone)) {
      const postData = { data: phone };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedPhone(true);
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedPhone(false);
            console.error("Verification failed");
          }
        })
        .catch((error) => {
          setisVerifiedPhone(false);
          console.error("Verification failed", error);
        });
    } else {
      setisVerifiedPhone();
    }
  }

  const [passwordError, setPasswordError] = useState(false);
  // Update this when the password input is edited
  const handlePasswordChange = (e) => {
    const newValue = e.target.value;
    // Limit length and allow valid characters
    if (newValue.length <= 32) {
      // Validate live feedback
      const isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,32}$/.test(newValue);
      setPasswordError(!isValid);
      setEditDetails({...editDetails, "password": newValue});
    }
  };
  const generatePassword = () => {
    const length = 12;
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const symbols = "@$!%*?&#^";
  
    const all = lower + upper + numbers + symbols;
  
    let newPassword = "";
    newPassword += lower[Math.floor(Math.random() * lower.length)];
    newPassword += upper[Math.floor(Math.random() * upper.length)];
    newPassword += numbers[Math.floor(Math.random() * numbers.length)];
    newPassword += symbols[Math.floor(Math.random() * symbols.length)];
  
    for (let i = 4; i < length; i++) {
      newPassword += all[Math.floor(Math.random() * all.length)];
    }
    // Shuffle newPassword to remove predictable pattern
    newPassword = newPassword
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
  
    setEditDetails({...editDetails, "password": newPassword});
    setPasswordError(false);
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleClose = () => {
    setShowEditDefault(false);
    setShowEdit(false);
  }

  const handleCloseBack = () => {
    setShowEditDefault(false);
    setShowEdit(true);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    const payload = {
      vendor_name: editDetails.vendor_name,
      username: editDetails.username,
      vendor_country: editDetails.vendor_country,
      password: editDetails.password,
      person_name: editDetails.person_name,
      email: editDetails.email,
      phone: editDetails.phone,
      website_url: editDetails.website_url,
      allow_ip: editDetails.allow_ip,
      account_validity: editDetails.account_validity,
    };

    setPreviewDetails(payload);
    setShowEdit(false);
    setShowEditDefault(true);
  }

  const submitEditForm = (e) => {
    e.preventDefault();

    const editedPostData = {
      ...previewDetails,
      id: editDetails.id,
    }

    // Continue with API call if password validation passes
      userDetailUpdates(editedPostData)
      .then((res) => {
        // If using RTK Query style response
        if (res.error) {
          console.log("error", res.error);
          setToastMessage(res.error?.data?.message || "Error Updating User details!");
          setToastVariant("danger");
        } else if (res.data?.statusCode === 200) {
          setShowEdit(false);
          setShowEditDefault(false);
          setEditDetails([]);
          setRefreshTable(!refreshTable);
          setToastMessage(res.data?.message || "User details Updated!");
          setToastVariant("success");
        } else {
          setToastMessage(res.data?.message || "Error Updating User details!");
          setToastVariant("danger");
        }
      })
      .catch((error) => {
        console.log("catch error", error);
        setToastMessage(error?.data?.message || "Error Updating User details!");
        setToastVariant("danger");
      })
      .finally(() => {
        setShowToast(true);
      });  
  };



  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      
      <div>
        <Modal backdrop="static" keyboard={false} size="lg" as={Modal.Dialog} centered show={showEdit} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title className="h6">Edit User Details</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            <Card className="m-0 border-0 p-0">
              <Row>
                <Col md={12}>
                <TableWrapper>
                    <tbody>
                      <tr>
                        <td className="border-0">Vendor Name</td>
                        <td className="border-0">
                          <input
                            type="text"
                            value={editDetails.vendor_name || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^[A-Za-z]*$/.test(val)) {
                                setEditDetails({ ...editDetails, vendor_name: val });
                              }
                            }}
                            minLength={3}
                            maxLength={50}
                            className="form-control"
                            pattern="^[a-zA-Z]$"
                            title="Vendor Name must be alphabetic entry, no spaces either."
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Username</td>
                        <td className="border-0">
                          <input
                            type="text"
                            value={editDetails.username || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^[A-Za-z0-9]*$/.test(val)) {
                                setEditDetails({ ...editDetails, username: val });
                              }
                            }}
                            className="form-control"
                            // pattern="^[a-zA-Z0-9]{0,30}$"
                            minLength={3}
                            maxLength={30}
                            title="Enter a valid username with 3–30 alphanumeric characters only, no spaces either."
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Vendor Country</td>
                        <td className="border-0">
                        <Select
                            options={countryOptions}
                            placeholder="Select Vendor"
                            className="mb-0"
                            isSearchable={true}
                            //getting label from table 
                            value={countryOptions.find(u => String(u.value) === String(editDetails.vendor_country)) || null}
                            onChange={(selectedOption) => {
                              setEditDetails({ ...editDetails, vendor_country: selectedOption.value });
                            }
                          }
                             // Ensure the dropdown appears over the card
                            menuPortalTarget={document.body} // Attach the dropdown to the body
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                borderRadius: '0.75rem',
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }), // High z-index
                            }}
   
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Contact Person Name</td>
                        <td className="border-0">
                          <input
                            type="text"
                            value={editDetails.person_name || ""}
                            minLength={3}
                            maxLength={50}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "" || /^[A-Za-z]*$/.test(val)) {
                                setEditDetails({ ...editDetails, person_name: val });
                              }
                            }}
                            className="form-control"
                            title="Enter a valid name with 3–50 alphabetic characters only, no spaces either."
                          />
                        </td>
                      </tr>
                         <tr>
                        <td className="border-0">Password</td>
                        <td className="border-0">
                          <div className="input-group">
                            {isEditPassword ? (
                              <>
                                <span className="input-group-text">
                                  <KeyIcon width={20} />
                                </span>
                                <input
                                  required
                                  type="password"
                                  maxLength={32}
                                  placeholder="Password"
                                  autoComplete="new-password"
                                  title="Password must be 8-32 characters, include uppercase, lowercase, number, and special character."
                                  value={editDetails.password}
                                  onChange={handlePasswordChange} // Use the new handler here
                                  className={`form-control ${passwordError ? "is-invalid" : ""}`}
                                />
                                <span
                                  className="input-group-text"
                                  onClick={generatePassword}
                                  style={{ cursor: 'pointer' }}
                                  title="Auto-generate password"
                                >
                                  <MdOutlineAutoMode size={20} />
                                </span>

                              </>
                            ) : (
                              <Button variant="light" onClick={() => setIsEditingPassword(!isEditingPassword)}>
                                <CiEdit size={25} />
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Email</td>
                        <td className="border-0">
                          <div className="input-group">
                            <span className="input-group-text">
                              <MailIcon width={20} />
                            </span>
                            <input
                              type="email"
                              value={editDetails.email || ""}
                              onChange={(e) => {
                                verifyEmail(e);
                              }}
                              placeholder="name@company.com"
                              className="form-control"
                              required
                            />
                            {isVerifiedEmail &&
                              <span className="input-group-text" title="Email is available and unique">
                                <CheckIcon width={20} className="text-success" />
                              </span>
                            }
                            {isVerifiedEmail === false &&
                              <span className="input-group-text" title="Email is not available or unique">
                                <XCircleIcon width={20} className="text-danger" />
                              </span>
                            }
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Contact Phone</td>
                        <td className="border-0">
                          <div className="input-group phone-input-group">
                            <PhoneInput
                              country="IN"
                              value={editDetails.phone || ""}
                              onChange={(value) => {
                                verifyPhone(value);
                              }}
                              title="Please enter a valid phone number in the format '+91 XXXXX-XXXXX'."
                              placeholder="+91 99999-99999"
                              style={{ width: "100%" }}
                            />

                            {isVerifiedPhone === true &&
                              <InputGroup.Text className="phone-input-icon" title="Phone number is available and unique">
                                <CheckIcon width={20} className="text-success" />
                              </InputGroup.Text>
                            }
                            {isVerifiedPhone === false &&
                              <InputGroup.Text className="phone-input-icon" title="Phone number is not available or unique">
                                <XCircleIcon width={20} className="text-danger " />
                              </InputGroup.Text>
                            }
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Website URL</td>
                        <td className="border-0">
                          <input
                            type="text"
                            value={editDetails.website_url || ""}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              const isValid = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/\S*)?$/.test(newValue.trim());
                    
                              if (newValue.length <= 32 && isValid) {
                                setEditDetails((prev) => ({
                                  ...prev,
                                  website_url: newValue,
                                }));
                              }
                           
                            }}
                            className="form-control"
                            pattern="^[a-zA-Z0-9]{0,30}$"
                            title="Enter a valid URL like https://example.com"
                          />
                        </td>
                      </tr>

                      <tr>
                        <td className="border-0">Allow IP</td>
                        <td className="border-0">
                          <div className="d-flex gap-1">
                            {[0, 1, 2, 3].map((index) => (
                              <input
                                key={index}
                                type="text"
                                value={(() => {
                                  const ipParts = editDetails.allow_ip ? editDetails.allow_ip.split('.') : ["", "", "", ""];
                                  return ipParts[index] || "";
                                })()}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "" || (/^\d{1,3}$/.test(val) && +val <= 255)) {
                                    const currentParts = editDetails.allow_ip ? editDetails.allow_ip.split('.') : ["", "", "", ""];
                                    const newParts = [...currentParts];
                                    newParts[index] = val;
                                    setEditDetails({ ...editDetails, allow_ip: newParts.join('.') });
                                  }
                                }}
                                style={{ width: "60px", textAlign: "center" }}
                                className="form-control"
                                maxLength={3}
                                minLength={1}
                                placeholder="0"
                              />
                            ))}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td className="border-0">Account Validity</td>
                        <td className="border-0">
                          <input
                            type="date"
                            value={editDetails.account_validity
                              ? moment(editDetails.account_validity, "DD/MM/YYYY", true).isValid()
                                ? moment(editDetails.account_validity, "DD/MM/YYYY").format("YYYY-MM-DD")
                                : moment(editDetails.account_validity).format("YYYY-MM-DD")
                              : ""}
                            onChange={(e) => {
                              const newDate = e.target.value;
                              // Convert from YYYY-MM-DD to DD/MM/YYYY for storage/API payload
                              const formattedDate = moment(newDate).format("YYYY-MM-DD");
                              setEditDetails({ ...editDetails, account_validity: formattedDate });
                            }}
                            className="form-control"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </TableWrapper>
                  {missingFields.length > 0 && (
                    <div className="mt-2">
                      <div className="fw-bold mb-1">Please fill the following required fields:</div>
                      <ul className="mb-0">
                        {missingFields.map((f) => (
                          <li key={f}>{fieldLabels[f] || f}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </Col>
              </Row>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleEditSubmit} disabled={!isValidated || (isEditPassword && (!!passwordError || !editDetails.password))}>
              Preview
            </Button>
          </Modal.Footer>
        </Modal>

{/* password confirmation */}
        <Modal backdrop="static" keyboard={false} as={Modal.Dialog} centered show={isEditingPassword && !isEditPassword} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title className="h6">Edit Password Confirmation</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={() => setIsEditingPassword(!isEditingPassword)} />
          </Modal.Header>
          <Modal.Body>
            <p>Once confirmed, you will be required to update your password.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setIsEditPassword(!isEditPassword);
              setEditDetails((prevDetails) => ({
                ...prevDetails,
                password: ""
              }));
            }}>
              Confirm
            </Button>
            <Button variant="link" className="text-gray ms-auto" onClick={() => setIsEditingPassword(!isEditingPassword)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal backdrop="static" keyboard={false} as={Modal.Dialog} centered show={showEditDefault} onHide={handleCloseBack}>
          <Modal.Header>
            <Modal.Title className="h6">Editted User Detail Preview</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={handleCloseBack} />
          </Modal.Header>
          <Modal.Body>
            <Card className="mb-2 mt-2">
              <Row>
                <Col md={10}>
                <TableWrapper>
                  <tbody>
                      {Object.entries(previewDetails || {})
                        .map(([key, value]) => (
                         <tr key={key}>
                           <td className="border-0 text-capitalize">{String(key).split("_").join(" ")}</td>
                           <td className="border-0" title={String(value)}>
                             {String(key).toLowerCase().includes('password') ? '********' : String(value)}
                           </td>
                         </tr>
                       ))}
                    </tbody>
                  </TableWrapper>
                </Col>
                <Col md={2} className="d-flex align-items-start">
                    <div>
                      {copied ? (
                        <Button size="sm" variant="success" className="copy-code-button">
                          Copied
                        </Button>
                      ) : (
                        <CopyToClipboard
                          text={Object.entries(previewDetails)
                            .map(([key, value]) => `${key}: ${value}`)
                            .join("\n")}
                          onCopy={handleCopy}
                        >
                          <Button size="sm" variant="secondary" className="copy-code-button">
                            Copy
                          </Button>
                        </CopyToClipboard>
                      )}
                    </div>
                </Col>
              </Row>
            </Card>

            <Card className="mb-2 mt-3">
              <Row>
                <Col md={12}>
                    <b>Share Details:</b>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="emailSwitch"
                        checked={selectedOption === 'email'}
                        onChange={() => setSelectedOption('email')}
                      />
                      <FormCheck.Label htmlFor="emailSwitch" style={{ marginLeft: '8px' }}>
                        Email ID
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="phoneSwitch"
                        checked={selectedOption === 'phone'}
                        onChange={() => setSelectedOption('phone')}
                      />
                      <FormCheck.Label htmlFor="phoneSwitch" style={{ marginLeft: '8px' }}>
                        Phone Number
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="bothSwitch"
                        checked={selectedOption === 'both'}
                        onChange={() => setSelectedOption('both')}
                      />
                      <FormCheck.Label htmlFor="bothSwitch" style={{ marginLeft: '8px' }}>
                        Both
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="noneSwitch"
                        checked={selectedOption === ''}
                        onChange={() => setSelectedOption('')}
                      />
                      <FormCheck.Label htmlFor="noneSwitch" style={{ marginLeft: '8px' }}>
                        None
                      </FormCheck.Label>
                    </FormCheck>
                </Col>
              </Row>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={(e) => submitEditForm(e)}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <VendorRegistrationListTable key={refreshTable} handleEdit={handleEdit} />
    </>
  );
};
